import { CONSTANTS } from "./helpers/constants.js";
import { getAccessToken, removeLocalStorageItem } from "./helpers/token.service.js";
import { decodeJwt } from "jose";

//#region src/validate-get-token.ts
const validateAndGetAccessToken = () => {
	const tokenKey = CONSTANTS.tokenKey;
	const token = getAccessToken();
	if (token) {
		const tokenExpiryDate = decodeJwt(token).exp;
		if (tokenExpiryDate && 1e3 * tokenExpiryDate > Date.now()) return token;
		else removeLocalStorageItem(tokenKey);
	}
};

//#endregion
export { validateAndGetAccessToken };